import { cn } from "@/lib/utils";
import type { NotificationCategory } from "./NotificationItem";

export type NotificationFilter =
  | { kind: "all" }
  | { kind: "unread" }
  | { kind: "category"; category: NotificationCategory };

interface NotificationFiltersProps {
  value: NotificationFilter;
  onChange: (next: NotificationFilter) => void;
}

const CATEGORIES: { key: NotificationCategory; label: string }[] = [
  { key: "leads", label: "Leads" },
  { key: "engine", label: "Engine" },
  { key: "tasks", label: "Tasks" },
  { key: "team", label: "Team" },
];

export function NotificationFilters({
  value,
  onChange,
}: NotificationFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Pill
        active={value.kind === "all"}
        onClick={() => onChange({ kind: "all" })}
        label="All"
      />
      <Pill
        active={value.kind === "unread"}
        onClick={() => onChange({ kind: "unread" })}
        label="Unread"
      />
      <span className="mx-1 h-5 w-px bg-slate-200" aria-hidden />
      {CATEGORIES.map((c) => (
        <Pill
          key={c.key}
          active={value.kind === "category" && value.category === c.key}
          onClick={() => onChange({ kind: "category", category: c.key })}
          label={c.label}
        />
      ))}
    </div>
  );
}

function Pill({
  active,
  onClick,
  label,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex h-8 items-center rounded-full border px-3 text-xs font-medium transition-colors",
        active
          ? "border-indigo-600 bg-indigo-600 text-white"
          : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:text-slate-900",
      )}
    >
      {label}
    </button>
  );
}
